import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ProductsAndPagesCourseBuilderChapterIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M19.5.237c1.19 0 2.166.925 2.245 2.096l.005.154v15.75c0 1.19-.925 2.166-2.096 2.245l-.154.005h-2.25v1.026c0 .644-.276 1.255-.752 1.68l-.135.11c-.56.426-1.286.566-1.964.379L3.9 20.765c-.973-.27-1.648-1.154-1.65-2.165V2.487c0-.703.328-1.365.887-1.79.392-.3.866-.457 1.348-.46H19.5zM4.586 1.742c-.19-.022-.385.03-.54.148-.187.142-.296.363-.296.597v16.111c0 .337.226.631.55.721l10.5 2.917c.226.063.468.016.654-.126.187-.142.296-.363.296-.597V5.877c0-.337-.225-.632-.58-.731L4.694 1.762zM15.6 3.709c.975.27 1.65 1.156 1.65 2.168v13.11h2.25c.38 0 .693-.282.743-.648l.007-.102V2.487c0-.38-.282-.693-.648-.743l-.102-.007H9.493z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ProductsAndPagesCourseBuilderChapterIcon = __decorateClass([
  customElement("elm-products-and-pages-course-builder-chapter-icon")
], ProductsAndPagesCourseBuilderChapterIcon);
export { ProductsAndPagesCourseBuilderChapterIcon };
